module.exports = __webpack_public_path__ + "media/images/icon_search_office-76e67250472a9012f596b0e93e47c724.png";